//component/MFASetupModal.js
import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Form, Modal, Row } from "react-bootstrap";
import { Button } from "../common/Button";
import { useDispatch } from "react-redux";
import { Key } from "@mui/icons-material";
import { startLogin, startRegistration } from "../webauthn";
import { is } from "date-fns/locale";
import { set } from "date-fns";

const PasskeyRegistrationModal = ({userId,orgId, handleClose,modalShow }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [passkeyName, setPasskeyName] = useState("");

    const handlePasskeyRegister = async () => {
        setIsLoading(true);
        const options = await startRegistration(userId, orgId, passkeyName);
        setIsLoading(false);
        handleClose();
    }


    return(
        <Modal
            size="lg"
            show={modalShow}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName
            backdrop={"static"}
            centered
            className="custom-dialog popup-org"
        >
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter" className="text-center w-100">
                    Passkey Register
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                <div>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <Key style={{ fontSize: "100px", color: "#005da8" }} />
                        <h4>Cross-Platform Passkey</h4>
                        <text>Example: YubiKey</text>
                    </div>
                
                                                            
                    <Form.Group className="mt-3">
                        <Form.Label>Name Your Passkey</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter a name for your passkey"
                                value={passkeyName}
                                onChange={(e) => setPasskeyName(e.target.value)}
                            />
                    </Form.Group>
                
                    <div className="action-wrap mt-3">
                        <Button onClick={handlePasskeyRegister} disabled={isLoading || !passkeyName}>
                        {isLoading ? <CircularProgress size={24} /> : "Register Passkey"}
                            </Button>
                            <Button onClick={handleClose} variant="secondary" className="ms-2">
                                Cancel
                            </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
        
    )
}

export default PasskeyRegistrationModal;